import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ImportReasonActions } from '../actions/ImportReasonActions';

export type ImportErrorReason = 'ALREADY_EXIST' | 'DEPENDENCY_NOT_FOUND' | 'UNKNOWN';

export interface ImportResponse {
  response: Record<
    string,
    {
      reason: ImportErrorReason;
      payload: string | Record<string, { id: string; args: Record<string, any> }[]>;
    }
  >;
}

export interface ImportReasonState {
  isOpen: boolean;
  reasons: ImportResponse;
}

const initialState: ImportReasonState = {
  isOpen: false,
  reasons: { response: {} },
};

export const importReasonReducer = (state: ImportReasonState = initialState, action: ReduxBaseAction<ImportReasonActions>) => {
  switch (action.type) {
    case 'OPEN_IMPORT_REASON_DIALOG':
      return {
        ...state,
        isOpen: true,
      };
    case 'CLOSE_IMPORT_REASON_DIALOG':
      return {
        ...state,
        isOpen: false,
      };
    case 'SET_IMPORT_REASON':
      return {
        ...state,
        reasons: action.payload,
      };
    case 'CLEAR_IMPORT_REASON':
      return {
        isOpen: false,
        reasons: {},
      };
    default: {
      return state;
    }
  }
};
